 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"chat":"chat","shop":"shop","gf":"gf","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","workouts":"workouts","dashboard":"dashboard","user":"user","HomeNew.vue":"HomeNew.vue","habit":"habit","social":"social","deviceManagement":"deviceManagement","event":"event","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"6188eb1f","chunk-04a70578":"7bb5421c","chunk-0c4c0fa9":"e18e6fcb","chunk-0a29cabe":"ac2530b4","chunk-23bef907":"433157ef","shop":"3383c93a","chunk-11faeb1d":"65643e43","chunk-157c2bc2":"b6a37610","gf":"0e60fc3e","chunk-1ae5ab22":"1f399709","chunk-1d2e3766":"36709c3d","chunk-855a8646":"4ae591fe","chunk-9826f532":"113a268a","chunk-c5a69156":"0fa6b3fd","chunk-3ce22e36":"63dfa427","chunk-7e2855ac":"c8e40ccc","chunk-1e90651e":"9cf00be5","chunk-217be9fa":"4eed72a2","admin":"3968b9f6","aliBey":"fe53abee","chunk-e155fa78":"df34cf1b","chunk-55f7525a":"3c00b403","chunk-38e96654":"60b824bf","chunk-5397765a":"cb163718","habit~nutrition":"f177cb18","nutrition":"791fef79","chunk-4ffaccba":"342c103a","einmalig":"11812fb0","chunk-502b709f":"c89c9c7a","chunk-59c5246e":"bb00ff84","workouts":"31e133cb","chunk-515fb775":"7927bbdf","chunk-b0bf58f2":"88f2a5fe","dashboard":"f68dc4be","chunk-f97e2e32":"fed43d7b","user":"be441627","chunk-9d9a3692":"7b6c4896","chunk-b067410a":"3dc4a508","chunk-e2d0aba2":"a91054ae","HomeNew.vue":"1a060ddd","chunk-ef2249dc":"92d13441","habit":"83096d28","chunk-225a75ab":"f3406550","chunk-2d0ae56b":"da7c86ae","chunk-2d0bff72":"dc1e6db2","chunk-2d0c8467":"38d19932","chunk-2d0dda10":"fc094788","chunk-2d225092":"6e15e463","chunk-351eb10e":"65eb063e","chunk-45c97c5e":"3dbde622","chunk-4f70ea14":"a5c96af8","chunk-d8cd5244":"e8952380","social":"98cbc539","deviceManagement":"282ce661","event":"9d0c2110","chunk-613e6a72":"37809a01","chunk-6f66eaa9":"2e27b580","chunk-7d3b971b":"f61716ec","chunk-b6599cc6":"a8eb4d6f","chunk-16d05c62":"d334cda4","friends":"9db8c201","payment":"09903989","redirection":"3acbed28","chunk-78f597ce":"a0771667","chunk-2d216214":"1cff4ebd","chunk-2d216257":"58872a85","chunk-59b2e543":"6cf6c8f0","chunk-2d0c13c4":"7813a997","chunk-2d209639":"94c15c44"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chat":1,"chunk-04a70578":1,"chunk-0c4c0fa9":1,"chunk-0a29cabe":1,"shop":1,"chunk-11faeb1d":1,"gf":1,"chunk-1ae5ab22":1,"chunk-1d2e3766":1,"chunk-855a8646":1,"chunk-9826f532":1,"chunk-c5a69156":1,"chunk-3ce22e36":1,"chunk-7e2855ac":1,"chunk-1e90651e":1,"chunk-217be9fa":1,"admin":1,"aliBey":1,"chunk-e155fa78":1,"chunk-55f7525a":1,"chunk-38e96654":1,"chunk-5397765a":1,"habit~nutrition":1,"nutrition":1,"chunk-4ffaccba":1,"einmalig":1,"chunk-502b709f":1,"chunk-59c5246e":1,"workouts":1,"chunk-515fb775":1,"chunk-b0bf58f2":1,"dashboard":1,"chunk-f97e2e32":1,"user":1,"chunk-9d9a3692":1,"chunk-b067410a":1,"chunk-e2d0aba2":1,"HomeNew.vue":1,"chunk-ef2249dc":1,"habit":1,"chunk-225a75ab":1,"chunk-351eb10e":1,"chunk-45c97c5e":1,"chunk-4f70ea14":1,"social":1,"deviceManagement":1,"event":1,"chunk-613e6a72":1,"chunk-6f66eaa9":1,"chunk-7d3b971b":1,"chunk-b6599cc6":1,"chunk-16d05c62":1,"friends":1,"chunk-78f597ce":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"chat":"chat","shop":"shop","gf":"gf","admin":"admin","aliBey":"aliBey","habit~nutrition":"habit~nutrition","nutrition":"nutrition","einmalig":"einmalig","workouts":"workouts","dashboard":"dashboard","user":"user","HomeNew.vue":"HomeNew.vue","habit":"habit","social":"social","deviceManagement":"deviceManagement","event":"event","friends":"friends","payment":"payment","redirection":"redirection"}[chunkId]||chunkId) + "." + {"chat":"18ca758b","chunk-04a70578":"d888e6e3","chunk-0c4c0fa9":"1a7a72fb","chunk-0a29cabe":"aa93e336","chunk-23bef907":"31d6cfe0","shop":"1674ba39","chunk-11faeb1d":"5c617ef9","chunk-157c2bc2":"31d6cfe0","gf":"c9855acb","chunk-1ae5ab22":"920258b6","chunk-1d2e3766":"5ee2c0e1","chunk-855a8646":"df716a94","chunk-9826f532":"1e86cea9","chunk-c5a69156":"927289a6","chunk-3ce22e36":"b8702556","chunk-7e2855ac":"e9a7a871","chunk-1e90651e":"f95702ee","chunk-217be9fa":"fd8c3217","admin":"8b0e383a","aliBey":"02841810","chunk-e155fa78":"a498c039","chunk-55f7525a":"60a0be50","chunk-38e96654":"9d3f5413","chunk-5397765a":"7481dedb","habit~nutrition":"551557c5","nutrition":"7d5e1320","chunk-4ffaccba":"df716a94","einmalig":"d24288df","chunk-502b709f":"58bd2dfb","chunk-59c5246e":"0259284e","workouts":"914adfd1","chunk-515fb775":"aa93e336","chunk-b0bf58f2":"0850582d","dashboard":"ea8e2b57","chunk-f97e2e32":"13dd5d1b","user":"842ffcc7","chunk-9d9a3692":"27247be2","chunk-b067410a":"b4b6f499","chunk-e2d0aba2":"234e9eff","HomeNew.vue":"fd7fd5c3","chunk-ef2249dc":"38cdad1c","habit":"346ce143","chunk-225a75ab":"deb99ca3","chunk-2d0ae56b":"31d6cfe0","chunk-2d0bff72":"31d6cfe0","chunk-2d0c8467":"31d6cfe0","chunk-2d0dda10":"31d6cfe0","chunk-2d225092":"31d6cfe0","chunk-351eb10e":"8b18ed18","chunk-45c97c5e":"e9b57efc","chunk-4f70ea14":"e234d813","chunk-d8cd5244":"31d6cfe0","social":"38002047","deviceManagement":"a40c19d5","event":"d8b22b17","chunk-613e6a72":"3fa4f906","chunk-6f66eaa9":"840f11ef","chunk-7d3b971b":"42eb04f9","chunk-b6599cc6":"b71a634a","chunk-16d05c62":"9d5e1cc3","friends":"52064fe5","payment":"31d6cfe0","redirection":"31d6cfe0","chunk-78f597ce":"f61c60b9","chunk-2d216214":"31d6cfe0","chunk-2d216257":"31d6cfe0","chunk-59b2e543":"31d6cfe0","chunk-2d0c13c4":"31d6cfe0","chunk-2d209639":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
